var Flickity = require('flickity');
import 'flickity-as-nav-for';

(() =>
{
	const stringToBoolean = string =>
	{
		if (!string)
		{
			return false;
		}
		switch (string.toLowerCase().trim())
		{
			case 'true': case 'yes': case '1': return true;
			case 'false': case 'no': case '0': case null: return false;
			default: return Boolean(string);
		}
	};
	document.addEventListener('DOMContentLoaded', () =>
	{
		let carouselEl = document.querySelector('.cp-carousel');
		let productCarouselEl = document.querySelector('.productimages__carousel-big');
		let productCarouselThumbnailsEl = document.querySelector('.productimages__carousel-thumbnails');
		let jumbotron__carouselEl = document.querySelector('.jumbotron__carousel');
		let jumbotron__carousel_mobileEl = document.querySelector('.jumbotron__carousel-mob');
		let productGroupCarouselEl = document.querySelector('.productgroup__carousel');
		let carousels = [...document.querySelectorAll('.carousel')];
		let relatedProductsEl = document.querySelector('.related-products__slider');
		let upsellProductsEl = document.querySelector('.upsell-products__slider');
		const contentProductCarouselsEls = [...document.querySelectorAll('.content-product-slider')];
		const productModuleCarouselsEls = [...document.querySelectorAll('.products-module__slider')];

		[jumbotron__carouselEl, carouselEl, productCarouselEl, productCarouselThumbnailsEl, productGroupCarouselEl, relatedProductsEl].forEach(carousel => {
			if (carousel && carousel.classList.contains('hidden'))
			{
				carousel.classList.remove('hidden');
				carousel.offsetHeight;
			}
		});

		if (carouselEl)
		{
			new Flickity(carouselEl, {
				autoPlay: true,
				pageDots: true,
				wrapAround: true,
				freeScroll: true,
			});
		}

		if (relatedProductsEl)
		{
			const relatedProducts = [...relatedProductsEl.querySelectorAll('.related-products__slider-cel')];
			const relatedProductsCount = relatedProducts.length;

			if (relatedProductsCount > 5)
			{
				relatedProductsEl.classList.add('related-products__slider--enabled');
				new Flickity(relatedProductsEl, {
					pageDots: false,
					contain: true,
					cellAlign: 'center',
					
				});
			}
		}

		if (upsellProductsEl)
		{
			const upsellProducts = [...upsellProductsEl.querySelectorAll('.related-products__slider-cel')];
			const upsellProductsCount = upsellProducts.length;

			if (upsellProductsCount > 5)
			{
				upsellProductsEl.classList.add('related-products__slider--enabled');
				new Flickity(upsellProductsEl, {
					pageDots: false,
					contain: true,
					cellAlign: 'center',
				});
			}
		}

		if (jumbotron__carouselEl)
		{
			new Flickity(jumbotron__carouselEl, {
				draggable: true,
				pageDots: false,
				wrapAround: true
			});
		}

		if (jumbotron__carousel_mobileEl) {
			new Flickity(jumbotron__carousel_mobileEl, {
				draggable: true,
				pageDots: false,
				wrapAround: true
			});
		}

		if (productCarouselEl) {
			new Flickity(productCarouselEl, {
				draggable: true,
				pageDots: false,
				wrapAround: true
			});
		}

		if (productCarouselThumbnailsEl)
		{
			new Flickity(productCarouselThumbnailsEl, {
				asNavFor: productCarouselEl,
				draggable: true,
				contain: true,
				pageDots: false,
				prevNextButtons: false
			});
		}

		if (productGroupCarouselEl)
		{
			new Flickity(productGroupCarouselEl, {
				draggable: true,
				contain: true,
				pageDots: true,
				prevNextButtons: true,
				wrapAround: true
			});
		}

		contentProductCarouselsEls.forEach(contentProductCarouselEl =>
		{
			new Flickity(contentProductCarouselEl, {
				pageDots: false,
				contain: true,
				cellAlign: 'left'
			});
		});

		productModuleCarouselsEls.forEach(productModuleCarouselsEl => {
			new Flickity(productModuleCarouselsEl, {
				watchCSS: true,
				pageDots: false,
				contain: true,
				cellAlign: 'left'
			});
		});

		carousels.forEach(carousel => {
			let groupAmount = parseInt(carousel.dataset.columns, 10);
			let duration = parseInt(carousel.dataset.duration, 10);
			let infiniteLoop = stringToBoolean(carousel.dataset.loop);
			let showDots = stringToBoolean(carousel.dataset.dots);
			let controls = stringToBoolean(carousel.dataset.controls);
			let autoPlay = stringToBoolean(carousel.dataset.autoplay);
			if (duration > 0) { autoPlay = duration; }
			new Flickity(carousel, {
				draggable: true,
				contain: true,
				freeScroll: false,
				pageDots: showDots,
				wrapAround: infiniteLoop,
				groupCells: groupAmount,
				autoPlay: autoPlay,
				prevNextButtons: controls,
				cellAlign: 'center',
			});
		});

	});

	// Added little hack for equal height carousel-cells 
	// https://github.com/metafizzy/flickity/issues/534
	Flickity.prototype._createResizeClass = function ()
	{
		this.element.classList.add('flickity-resize');
	};

	Flickity.createMethods.push('_createResizeClass');

	// eslint-disable-next-line prefer-destructuring
	const resize = Flickity.prototype.resize;

	Flickity.prototype.resize = function ()
	{
		this.element.classList.remove('flickity-resize');
		resize.call(this);
		this.element.classList.add('flickity-resize');
	};

})();

